"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _angleBrackets = _interopRequireDefault(require("@atlaskit/icon/core/angle-brackets"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesCodeIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><path fill="inherit" d="m15.652 12.014-1.367-1.367a.98.98 0 0 1 .005-1.38.973.973 0 0 1 1.38-.005l2.02 2.022a.95.95 0 0 1 .219.339.97.97 0 0 1-.193 1.096l-2.02 2.02a.98.98 0 0 1-1.378-.006.973.973 0 0 1-.006-1.379zm-9.56-.391a.95.95 0 0 1 .217-.34l2.022-2.02a.973.973 0 0 1 1.38.004.98.98 0 0 1 .004 1.38l-1.367 1.367 1.34 1.34a.98.98 0 0 1-1.384 1.384l-2.02-2.02a.97.97 0 0 1-.193-1.095m7.19-3.572c.546.177.844.763.667 1.308l-1.924 5.923a1.038 1.038 0 1 1-1.974-.641l1.924-5.923a1.04 1.04 0 0 1 1.308-.667"/></svg>`
}, props, {
  newIcon: _angleBrackets.default
}));
MediaServicesCodeIcon.displayName = 'MediaServicesCodeIcon';
var _default = exports.default = MediaServicesCodeIcon;